(function(global) {
  "use strict";

  var LINK_SELECTOR = "[data-product-back-link]";
  var LABEL_SELECTOR = "[data-product-back-label]";

  function normalizePathname(pathname) {
    if (pathname === "/") {
      return pathname;
    }

    return pathname.replace(/\/+$/, "");
  }

  function getSafeInternalReferrer(referrer, currentHref) {
    if (!referrer || !currentHref) {
      return null;
    }

    try {
      var referrerUrl = new URL(referrer);
      var currentUrl = new URL(currentHref);

      if (referrerUrl.origin !== currentUrl.origin) {
        return null;
      }

      if (normalizePathname(referrerUrl.pathname) === normalizePathname(currentUrl.pathname)) {
        return null;
      }

      return referrerUrl.href;
    } catch (error) {
      return null;
    }
  }

  function isPlainPrimaryClick(event, link) {
    var target = (link.target || "").toLowerCase();

    return event.button === 0 &&
      !event.metaKey &&
      !event.ctrlKey &&
      !event.shiftKey &&
      !event.altKey &&
      (target === "" || target === "_self") &&
      !link.hasAttribute("download");
  }

  function hasUsableInternalHistory(environment) {
    return Boolean(
      environment &&
      environment.history &&
      environment.history.length > 1 &&
      getSafeInternalReferrer(environment.referrer, environment.currentHref)
    );
  }

  function handleBackLinkClick(event, link, environment) {
    if (!event || !link || !isPlainPrimaryClick(event, link) || !hasUsableInternalHistory(environment)) {
      return false;
    }

    event.preventDefault();
    environment.history.back();
    return true;
  }

  function getDefaultEnvironment() {
    return {
      referrer: global.document.referrer,
      currentHref: global.location.href,
      history: global.history
    };
  }

  function initializeLinks(root, environment) {
    var scope = root || global.document;
    var runtime = environment || getDefaultEnvironment();
    var links = scope.querySelectorAll(LINK_SELECTOR);

    for (var index = 0; index < links.length; index += 1) {
      var link = links[index];

      if (link.dataset.productBackEnhanced === "true") {
        continue;
      }

      link.dataset.productBackEnhanced = "true";

      if (!hasUsableInternalHistory(runtime)) {
        continue;
      }

      var backLabel = link.getAttribute("data-back-label");
      var label = link.querySelector(LABEL_SELECTOR);

      if (backLabel) {
        if (label) {
          label.textContent = backLabel;
        }

        link.setAttribute("aria-label", backLabel);
      }

      link.addEventListener("click", function(event) {
        handleBackLinkClick(event, event.currentTarget, runtime);
      });
    }
  }

  global.BmProductBackNavigation = {
    getSafeInternalReferrer: getSafeInternalReferrer,
    handleBackLinkClick: handleBackLinkClick,
    initializeLinks: initializeLinks
  };

  if (global.document.readyState === "loading") {
    global.document.addEventListener("DOMContentLoaded", function() {
      initializeLinks(global.document);
    }, { once: true });
  } else {
    initializeLinks(global.document);
  }

  global.document.addEventListener("shopify:section:load", function(event) {
    initializeLinks(event.target);
  });
})(window);
